import { PdfPage } from 'views/CreateNewBudget/PdfPage';

const PdfRoute = {
    path: '/main/orcamento-vendas-pdf',
    element: <PdfPage />
};

export default PdfRoute;
